import { Category } from "app/modules/masters/categories/models/category.model";

export interface CategoryState {
  categories: Category[];
  loading: boolean;
  loaded: boolean;
  error: string | null;
  nameExists: boolean | null;
  codeExists: boolean | null;
  nameCheckError: string | null;
  codeCheckError: string | null;
}

export const initialCategoryState: CategoryState = {
  categories: [],
  loading: false,
  loaded: false,
  error: null,
  nameExists: null,
  codeExists: null,
  nameCheckError: null,
  codeCheckError: null,
};
